<template>
	<nuxt />
</template>

<script>
	export default {
		name: 'empty'
	}
</script>